import VueI18n, { Path, TranslateResult } from 'vue-i18n';
import Vue from 'vue';

import en from '@adobe/edex/ui/shared/i18n/en-us.json';

Vue.use(VueI18n);

export const vueI18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: { en },
});

// Extends the i18n $t injected method itself, this works with vue-ally plugin in vscode
// https://github.com/kazupon/vue-i18n/blob/9a2444976f058e30f2922275b6e6440ab63f45c1/src/extend.js#L11
Vue.prototype.$t = function (key: Path, ...values: any): TranslateResult {
  const i18n = this.$i18n || vueI18n;
  if (!i18n._te(key, i18n.locale, i18n._getMessages())) {
    // If the key is not found in the file, but it has a second param, use it as fallback
    return values && values.length > 0 ? values[0] : key;
  }
  return i18n._t(key, i18n.locale, i18n._getMessages(), this, ...values);
};
